import {
  LINK_CAROUSEL__LIST_CLASS,
  minBreakpoints,
} from '@noths/polaris-client-ribbons-design-system';
import {
  mediaQuery,
  pxToRem,
  responsiveFontSize,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { ICON_BUTTON__BUTTON_CLASS } from 'src/components/atoms/IconButton';
import { ACCORDION__HEADING_CLASS } from 'src/components/molecules/Accordion';

const { spacing, text, colors } = theme;

/*
 * #1: Temporary styles to keep styling closer to other pages.
 *     (See https://notonthehighstreet.atlassian.net/browse/FFA-625)
 */
const pageHeadingFontCSS = css`
  ${/*
    text-transform: capitalize; See comment #1
    See comment #1
  */ ''}
  text-transform: uppercase;
  color: ${colors.blackPearl};
  ${responsiveFontSize(text.xxl)};
  font-weight: 600;
  text-align: center;
`;

export const pageHeadingWrapperCSS = css`
  h1 {
    ${pageHeadingFontCSS}
  }
`;

export const copyBlockContentCSS = css`
  overflow: auto;
  display: flex;
  justify-content: center;

  a {
    color: ${colors.blueNavy};
  }
  p {
    margin: ${stack(spacing.xs)};
    max-width: ${pxToRem(776)};
    text-align: center;
    color: ${colors.blackPearl};
  }
`;

export const pageHeadingCSS = css`
  margin: ${stack(spacing.xl)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${stack(0)};
    `,
  )};
`;

export const copyBlockAccordionCSS = css`
  .${ACCORDION__HEADING_CLASS} {
    .${ICON_BUTTON__BUTTON_CLASS} {
      display: flex;
      align-items: center;
      ${pageHeadingFontCSS}
    }
  }
`;

export const linksCarouselSection = css`
  display: flex;
  justify-content: center;
`;

export const insetSectionContent = css`
  max-width: 776px;
`;

export const linksCarouselWrapper = css`
  width: 100%;
  margin-top: ${pxToRem(spacing.md)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${pxToRem(spacing.md)} 0;
    `,
  )};

  .${LINK_CAROUSEL__LIST_CLASS} {
    margin: ${pxToRem(spacing.sm)} 0;
  }
`;
